(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    console.log('çalıştı');
  function renderFacetG(e) {
    console.log(e);
    if ($(e).attr('checked')) {
      $(e).removeAttr('checked');
    } else {
      $(e).attr('checked', true);
    }

    // Label bul
    var label = $(e).closest('li').find('label');
    console.log('Burada', label);
    // Class toggle
    label.toggleClass('facet-checkbox--color1');
  }
  } catch(e) { console.error(e); }
})();

})();
